import { API2_HOST } from '@/utils/constants';

import fetchData from '../http';
import { IBaseResponse, IResult } from '../types/common';

// 提交商户信息
export function submitMerchantInfo(params: any) {
  return fetchData.post<IBaseResponse<any>>(
    `${API2_HOST}/oauth/v1/private/manager/commit`,
    {
      body: JSON.stringify(params),
    },
  );
}

// 获取商户密钥信息
export function getMerchantSecretInfo() {
  return fetchData.get<IBaseResponse<any>>(
    `${API2_HOST}/oauth/v1/private/manager/show`,
  );
}

// 重置密钥
export function resetMerchantSecret(params: {
  code_email: string;
  code_2fa: string;
  from: number;
}) {
  return fetchData.post<IBaseResponse<any>>(
    `${API2_HOST}/oauth/v1/private/manager/reset`,
    {
      body: JSON.stringify(params),
    },
  );
}

export const uploadImageUrl = `${API2_HOST}/oauth/v1/private/manager/upload`;
